import {store} from "bukku/redux/store";
import {Type} from 'bukku/redux/Transaction/helper';
import {RowType} from "./Rows/RowType";
import { SubscriptionCheck } from "../../Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../Access/helper/subscription/enum/SubscriptionScopeKey";

function iterNormalizeData(item, parentId = null, settings = {}) {
    const { Auth } = store.getState();
    const isMalaysianCompany = Auth.companyCountryCode === 'MY';

    const hasUOMSubscription = SubscriptionCheck
        .withKeys(SubscriptionScopeKey["PRODUCT.MULTI_UOM"]).hasSubscriptionTo();
    const hasMultiLocationSubscription = SubscriptionCheck
        .withKeys(SubscriptionScopeKey["INVENTORY.MULTI_LOCATION"]).hasSubscriptionTo();

    const getProductUnitId = () => {
        if (!hasUOMSubscription)
            return undefined;

        return (
            item.product_unit_id || item.product_unit_id === 0 ?
                item.product_unit_id :
                null
        );
    };

    switch (item.type) {
        case RowType.subtotal:
            return {
                id: item.id || undefined,
                type: item.type,
            };
        case RowType.subtitle:
            return {
                id: item.id || undefined,
                type: item.type,
                description: item.description || null,
            };
        case RowType.bundle:
            return {
                id: item.id || undefined,
                type: item.type,
                product_id: item.product_id || null,
                description: item.description || null,
                quantity: Number.isNaN(parseFloat(item.quantity)) ? 1 : parseFloat(item.quantity),
                transfer_item_id: item.transfer_item_id || undefined,
                children: (item?.children || []).map(child => iterNormalizeData(child, item.id, settings)),
            };
        case RowType.bundle_discount:
            return {
                id: item.id || undefined,
                parent_id: parentId,
                quantity: 1,
                type: item.type,
                account_id: item.account_id || null,
                description: item.description || null,
                discount: item.discount || null,
                tax_code_id: item.tax_code_id || null,
            };
        case RowType.bundle_item:
        case RowType.item:
        default: {
            const locationId = item.location_id || item.location_id === 0 ? item.location_id : null;
            return {
                id: item.id || undefined,
                parent_id: parentId,
                type: (item.type === RowType.item ? null : (item.type || null)),
                product_id: item.product_id || null,
                description: item.description || null,
                service_date: settings.service_date_on ? (item.service_date || null) : undefined,
                account_id: item.account_id || null,
                quantity: Number.isNaN(parseFloat(item.quantity)) ? 1 : parseFloat(item.quantity),
                location_id: hasMultiLocationSubscription ? locationId : undefined,
                product_unit_id: getProductUnitId(),
                // product_unit_id: (
                //     item.product_unit_id || item.product_unit_id === 0 ?
                //         item.product_unit_id :
                //         null
                // ),
                unit_price: parseFloat(item.unit_price) || 0,
                discount: item.discount || null,
                tax_code_id: item.tax_code_id || null,
                transfer_item_id: item.transfer_item_id || undefined,
                classification_code: isMalaysianCompany ?
                    item.classification_code || null : undefined,
            };
        }
    }
}

export const FormItemHelper = {
    normalizeData(formItems) {
        const { List } = store.getState();
        const { settings } = List;

        if (formItems)
            return formItems.map(formItem => iterNormalizeData(formItem, null, settings));

        return [];
    },
    supportedTypesForServiceDate: [
        Type.sale_quote,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_credit_note,
    ],
};
